import React from 'react';
import { Section } from './ui/Section';
import { Truck, ShieldCheck, Lock } from 'lucide-react';
export function OfferStack() {
  return <Section className="pb-0" data-id="element-477">
      <div className="bg-white border-2 border-[#D4AF37] rounded-3xl p-8 md:p-12 max-w-4xl mx-auto shadow-2xl relative overflow-hidden" data-id="element-478">
        <div className="absolute top-0 right-0 bg-[#D4AF37] text-white px-8 py-2 rounded-bl-2xl font-bold" data-id="element-479">
          OFERTA LIMITADA
        </div>

        <div className="text-center mb-10" data-id="element-480">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4" data-id="element-481">
            Prueba StingFit Sin Riesgos
          </h2>
          <p className="text-lg text-gray-600" data-id="element-482">
            Estamos tan seguros de que te encantará, que asumimos todo el
            riesgo.
          </p>
        </div>

        <div className="grid md:grid-cols-3 gap-8 text-center" data-id="element-483">
          <div className="flex flex-col items-center" data-id="element-484">
            <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-485">
              <Truck className="w-8 h-8 text-[#2D5016]" data-id="element-486" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-487">Envío Gratis</h3>
            <p className="text-sm text-gray-500" data-id="element-488">
              A toda España. Sin costes ocultos.
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-489">
            <div className="w-24 h-24 mb-4 flex items-center justify-center" data-id="element-490">
              <img src="https://cdn.magicpatterns.com/uploads/p4Y8eNPu4hukRzX7RH4BpD/imgi_19_1768343358-Untitled_design_(57).png" alt="Garantía 90 Días" className="w-full h-full object-contain" data-id="element-491" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-492">Garantía 90 Días</h3>
            <p className="text-sm text-gray-500" data-id="element-493">
              Si no ves resultados, te devolvemos tu dinero. Sin preguntas.
            </p>
          </div>

          <div className="flex flex-col items-center" data-id="element-494">
            <div className="w-16 h-16 bg-green-50 rounded-full flex items-center justify-center mb-4" data-id="element-495">
              <Lock className="w-8 h-8 text-[#2D5016]" data-id="element-496" />
            </div>
            <h3 className="font-bold text-gray-900 mb-2" data-id="element-497">Pago Seguro</h3>
            <p className="text-sm text-gray-500" data-id="element-498">
              Tus datos están protegidos con encriptación SSL de 256-bits.
            </p>
          </div>
        </div>
      </div>
    </Section>;
}